import {
  GroupOrderIntroCard,
  GroupOrderIntroCarousel,
  GroupOrderIntroDots,
  GroupOrderIntroFooter,
  GroupOrderIntroModal,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderIntro = {
  Modal: GroupOrderIntroModal,
  Carousel: GroupOrderIntroCarousel,
  Card: GroupOrderIntroCard,
  Dots: GroupOrderIntroDots,
  Footer: GroupOrderIntroFooter,
};
